export const ADMIN_CAPABILITIES = {
  CORRECT_OFFICIAL_MATERIALS: "content_quality.can_correct_official_materials",
} as const;

export type AdminCapability =
  (typeof ADMIN_CAPABILITIES)[keyof typeof ADMIN_CAPABILITIES];

export const hasAdminCapability = (
  capabilities: readonly string[] | null | undefined,
  capability: AdminCapability,
) => capabilities?.includes(capability) === true;

export const canCorrectOfficialMaterials = (
  capabilities: readonly string[] | null | undefined,
) =>
  hasAdminCapability(
    capabilities,
    ADMIN_CAPABILITIES.CORRECT_OFFICIAL_MATERIALS,
  );

export const getAdminDashboardEntryPath = (permissions: {
  isStaff: boolean;
  isSuperuser: boolean;
  adminCapabilities?: readonly string[];
}) => {
  if (permissions.isStaff || permissions.isSuperuser) {
    return "/admin-dashboard/home";
  }
  if (canCorrectOfficialMaterials(permissions.adminCapabilities)) {
    return "/admin-dashboard/content-quality";
  }
  return null;
};

export const isContentQualityReviewerRoute = (path: string) => {
  const [pathname] = path.split(/[?#]/, 1);
  return /^\/admin-dashboard\/content-quality(?:\/\d+|\/revisions\/\d+\/preview\/(?:original|revised))?\/?$/.test(
    pathname,
  );
};

export const shouldDeferContentQualityAuthorization = (
  path: string,
  hasAuthenticatedSession: boolean,
) => hasAuthenticatedSession && isContentQualityReviewerRoute(path);

export const getContentQualityAccessDeniedDestination = (permissions: {
  isTeacher: boolean;
  isStudent: boolean;
  isStaff: boolean;
  isSuperuser: boolean;
}) => {
  if (permissions.isTeacher) {
    return "/dashboard/home";
  }
  if (permissions.isStudent) {
    return "/student-dashboard/home";
  }
  if (permissions.isStaff || permissions.isSuperuser) {
    return "/admin-dashboard/home";
  }
  return "/";
};
